import React from 'react';
import { Grid } from '@mui/material';

import { ModuleSearchField, SearchSelectField, SelectField, SimpleTextField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function SocialNetworksDetailsSectionInfo(
	props: DetailsSectionInfoContentProps & { disableIdentityAssociation?: boolean }
) {
	const { t } = useSettings('socialnetworks');

	const [table, setTable] = React.useState(props.model.sone_table);
	const [tableItem, setTableItem] = React.useState<string | null>(
		props.model.sone_table_uid || props.model.peop_uid || props.model.comp_uid || props.model.user_uid
	);

	function handleTableChange(name, value) {
		setTable(value);
		setTableItem(null);
		props.sendChange(name, value);
	}

	function handleTableItemChange(name, value) {
		setTableItem(value);
		props.sendChange(name, value);
	}

	return (
		<>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TYPE */}
				<SearchSelectField
					name="sone_soty_id"
					label={t('DETAILS_SOCIALNETWORKS_FIELD_TYPE')}
					systable="socialnetworks_types"
					value={props.model.sone_soty_id}
					isEdit
					sendChange={props.sendChange}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* DESCRIPTION */}
				<SimpleTextField
					name="sone_description"
					label={t('DETAILS_SOCIALNETWORKS_FIELD_DESCRIPTION')}
					value={props.model.sone_description}
					isEdit
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={12}>
				{/* URL */}
				<SimpleTextField
					name="sone_title"
					label={t('DETAILS_SOCIALNETWORKS_FIELD_URL')}
					value={props.model.sone_title}
					isEdit
					sendChange={props.sendChange}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			{!props.disableIdentityAssociation && (
				<>
					<Grid size={{ sm: 4, xs: 12 }}>
						{/* SOCIAL NETWORK SOURCE TABLE */}
						<SelectField
							name="sone_table"
							label={t('CONTACTS_LINKED_TABLE')}
							options={[
								{ value: 'companies', title: t('MODULE_COMPANIES_NAME') },
								{ value: 'people', title: t('MODULE_PEOPLE_NAME') },
								{ value: 'users', title: t('MODULE_USERS_NAME') }
							]}
							value={table}
							isEdit
							sendChange={handleTableChange}
						/>
					</Grid>
					<Grid size={{ sm: 8, xs: 12 }}>
						{/* SOCIAL NETWORK ASSOCIATED ITEM */}
						{table ? (
							<ModuleSearchField
								name="sone_table_uid"
								label={t(`MODULE_${table}_NAME`)}
								module={table}
								uid={tableItem}
								isEdit
								sendChange={handleTableItemChange}
								required
								validationError={t('ERROR_TEXT_REQUIRED')}
							/>
						) : (
							<></>
						)}
					</Grid>
				</>
			)}
		</>
	);
}
